<template>
    <div class="box-list">
        <base-summary-box color="#6c6c6c">
            <template v-slot:icon>
                <i class="fas summary-icon fa-user-hard-hat"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.totalEmployee')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.total) }}</span>
            </template>
        </base-summary-box>

        <base-summary-box color="#6c98ba">
            <template v-slot:icon>
                <i class="far summary-icon fa-business-time"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.checkInOnTime')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.normal) }}</span>
            </template>
        </base-summary-box>

        <base-summary-box color="#d76436">
            <template v-slot:icon>
                <i class="far summary-icon fa-stopwatch"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.late')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.late) }}</span>
            </template>
        </base-summary-box>

        <base-summary-box color="#aa1a11">
            <template v-slot:icon>
                <i class="fas summary-icon fa-home-alt"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.absent')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.absent) }}</span>
            </template>
        </base-summary-box>

        <base-summary-box color="#cca972">
            <template v-slot:icon>
                <i class="fas summary-icon fa-hard-hat"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.onstie')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.onsite) }}</span>
            </template>
        </base-summary-box>

        <base-summary-box color="#a8a8a8">
            <template v-slot:icon>
                <i class="far summary-icon fa-door-open"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{$vuetify.lang.t('$vuetify.employeeSummaryBox.leave')}}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $util.formatNumber(employeeData.leave) }}</span>
            </template>
        </base-summary-box>
    </div>
</template>

<script>
import BaseSummaryBox from '@/components/BaseSummaryBox'

export default {
    name: 'EmployeeSummaryBox',

    components: {
        BaseSummaryBox
    },

    props: {
        employeeData: {
            type: Object,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.summary-icon {
    color: white;
    font-size: 20px;
    margin-left: 0.25rem;
}
.box-list {
    margin-top: 26px;
    margin-bottom: 30px;
    display: flex;

    & > *:not(:first-child) {
        margin-left: 1.5rem
    }

    // .box {
    //     background-color: #6c6c6c;
    //     color: white;
    // }

    .icon {
        width: 21px;
        height: 24px;
    }

    @media only screen and (max-width: 1350px) {
        & > *:not(:first-child) {
            margin-left: 1rem
        }
    }

    @media only screen and (max-width: 1308px) {
        overflow-x: auto;

        & > *:not(:first-child) {
            margin-left: 1%
        }
    }
}
</style>
